import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Layout from 'src/components/Octopath/layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const NoCait = makeShortcode("NoCait");
const Battle = makeShortcode("Battle");
const Cait = makeShortcode("Cait");
const Menu = makeShortcode("Menu");
const layoutProps = {
  _frontmatter
};

const MDXLayout = ({
  children
}) => <Layout>{children}</Layout>;

export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="Octopath Traveler Primrose AMS 2022" mdxType="SEO" />
    <h3 {...{
      "id": "tressa-ch1"
    }}>{`Tressa Ch.1`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Wolf’s Bow`}</strong>{`.`}</p>
    <NoCait mdxType="NoCait">Kill Pirate.</NoCait>
    <p>{`Run/Break from all encounters. Heal before boss if not full HP.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mikk-and-makk"
      }}>{`Mikk and Makk`}</h4>
      <p>{`T1-3: Tradewinds Mikk`}<br parentName="p"></br>{`
`}{`T4: Tradewinds x4 Mikk (kill)`}<br parentName="p"></br>{`
`}{`T5-6: Tradewinds / Grape`}<br parentName="p"></br>{`
`}{`T7: Tradewinds x4`}<br parentName="p"></br>{`
`}{`T8: Bow`}<br parentName="p"></br>{`
`}{`T9: Defend`}<br parentName="p"></br>{`
`}{`T10: Bow`}<br parentName="p"></br>{`
`}{`T11: Tradewinds x4`}</p>
    </Battle>
    <Cait mdxType="Cait">
      <p>{`Tag `}<strong parentName="p">{`Atlasdam`}</strong>{`, head to `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Find a Cait along the way and kill it with `}<strong parentName="p">{`Ice M`}</strong>{`.`}</p>
      <p>{`To deal with the Scholar shrine encounter, you can either run OR teach `}<strong parentName="p">{`Hired Help`}</strong>{` before the encounter and do HHDx2, Bow, then Bow x2.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "jobs"
        }}>{`Jobs`}</h5>
        <p>{`Tressa: `}<strong parentName="p">{`Scholar`}</strong>{`, Firestorm, Blizzard`}</p>
        <h5 {...{
          "id": "skills"
        }}>{`Skills`}</h5>
        <p>{`Tressa: Evasive Maneuvers`}</p>
      </Menu>
    </Cait>
    <NoCait mdxType="NoCait">
      <p>{`Go to `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
      <h3 {...{
        "id": "cyrus-ch1"
      }}>{`Cyrus Ch.1`}</h3>
      <p>{`Kill 2 encounters in Subterranean Study`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "skills-1"
        }}>{`Skills`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Hired Help`}</li>
        </ul>
      </Menu>
      <Battle mdxType="Battle">
        <h4 {...{
          "id": "russell"
        }}>{`Russell`}</h4>
        <h5 {...{
          "id": "turn-1"
        }}>{`Turn 1`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Defend`}</li>
          <li parentName="ul">{`Tressa: Ice M`}</li>
        </ul>
        <h5 {...{
          "id": "turn-2"
        }}>{`Turn 2`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Attack x3`}</li>
          <li parentName="ul">{`Tressa: HHD x3`}</li>
        </ul>
      </Battle>
      <p>{`Optionally buy `}<strong parentName="p">{`Thunder S`}</strong>{`. Scrutinize & pick `}<strong parentName="p">{`Light M`}</strong>{`.`}</p>
      <p>{`Go to `}<strong parentName="p">{`Whistlewood`}</strong>{`, kill with Light M. Grind battles with HHB until 130JP on Cyrus.`}</p>
      <Menu mdxType="Menu">
        <h5 {...{
          "id": "skills-2"
        }}>{`Skills`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Lightning Bolt + Firestorm`}</li>
        </ul>
        <h5 {...{
          "id": "equip-skills"
        }}>{`Equip Skills`}</h5>
        <ul>
          <li parentName="ul">{`Cyrus: Evasive Maneuvers`}</li>
        </ul>
      </Menu>
      <p>{`Get `}<strong parentName="p">{`Scholar Shrine`}</strong>{`.`}</p>
    </NoCait>
    <p>{`Tag `}<strong parentName="p">{`Noblecourt`}</strong>{`, head to & tag `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Rippletide`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`$1200`}</strong>{`, tag `}<strong parentName="p">{`Cobbleston`}</strong>{` and head towards `}<strong parentName="p">{`North Stonegard Pass`}</strong>{`.`}</p>
    <p>{`Get `}<strong parentName="p">{`Warrior Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stonegard`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Go to `}<strong parentName="p">{`Moonstruck Coast`}</strong>{`. S&Q at save, get `}<strong parentName="p">{`Merchant Shrine`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Goldshore`}</strong>{`. `}<NoCait mdxType="NoCait">{`Scrutinize `}<strong parentName="p">{`Thunder L`}</strong>{`. `}</NoCait>{`Head towards `}<strong parentName="p">{`Grandport`}</strong>{`.`}<br parentName="p"></br>{`
`}<strong parentName="p">{`West Grandport Coast`}</strong>{` get `}<strong parentName="p">{`$20000`}</strong>{`, and save/reload at save point. Pick `}<strong parentName="p">{`Thunder L`}</strong>{`, enter `}<strong parentName="p">{`Grandport`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Unerring Bracelet`}</strong>{`. Buy `}<strong parentName="p">{`Nourishing M`}</strong>{` and `}<strong parentName="p">{`Magic M`}</strong>{`. Buy `}<strong parentName="p">{`HGB & All Poms`}</strong>{`. Pick all the money. TP `}<strong parentName="p">{`Cobbleston`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Tag `}<strong parentName="p">{`Sunshade`}</strong>{`, `}<strong parentName="p">{`Clearbrook`}</strong>{`, and enter `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-start"
    }}>{`Tressa Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Thunder L`}</strong>{`, `}<strong parentName="p">{`Thunder M`}</strong>{`. Buy `}<strong parentName="p">{`Shadow M`}</strong>{`, `}<strong parentName="p">{`Fire M`}</strong>{`, and `}<strong parentName="p">{`Light M`}</strong>{`. Pick `}<strong parentName="p">{`Fool's Gold Ore`}</strong>{` and after last purchase TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <p>{`Head east to the next screen. Go to Weapon Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy"
      }}>{`Buy`}</h5>
      <p>{`Elemental Robe`}</p>
    </Menu>
    <p>{`Buy `}<strong parentName="p">{`3M Stones`}</strong>{`, buy `}<strong parentName="p">{`Elemental Augmentor`}</strong>{`, then TP back to `}<strong parentName="p">{`Quarrycrest`}</strong>{` and head to `}<strong parentName="p">{`Bolderfall`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch1"
    }}>{`Therion Ch.1`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "heathcote"
      }}>{`Heathcote`}</h4>
      <p>{`Thunder L`}<NoCait mdxType="NoCait">{` + M Stone`}</NoCait></p>
    </Battle>
    <p>{`Steal `}<strong parentName="p">{`Energizing Pomegranate, Nourishing Nut`}</strong>{` from lady by entrance.`}</p>
    <blockquote>
      <p parentName="blockquote">{`You have 4 L Stones you can use for clearing battles, 2 Thunder L, Wind L, Light L. This doesn't include non-cait Goldshore Thunder L. Keep track of how many you use, it will influence your Steals in Prim 4.`}</p>
    </blockquote>
    <p>{`Tag `}<strong parentName="p">{`Victor’s Hollow`}</strong>{`, Purchase `}<strong parentName="p">{`Nourishing M, Magic M`}</strong>{` from the man by the entrance. Get `}<strong parentName="p">{`Hunter Shrine`}</strong>{` and `}<strong parentName="p">{`Olive L`}</strong>{`. `}</p>
    <blockquote>
      <p parentName="blockquote">{`Controller Cleric Shrine movement: hold slighly above diagonal down-right on screen entry, switch to diagonal down-right after 2nd pole.`}</p>
    </blockquote>
    <p>{`Get `}<strong parentName="p">{`Cleric Shrine`}</strong>{`, tag `}<strong parentName="p">{`Stillsnow`}</strong>{`, and go to `}<strong parentName="p">{`Maw of the Ice Dragon`}</strong>{`. Get `}<strong parentName="p">{`$30000`}</strong>{` in the first red chest you see and `}<strong parentName="p">{`Adamantine Hat`}</strong>{` in the purple chest to the south.  `}</p>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, `}</p>
    <h3 {...{
      "id": "therion-ch2-start"
    }}>{`Therion Ch.2 Start`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Empowering Bracelet & Pom S`}</strong>{`. Do Therion Ch.2 up until Tavern.`}</p>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Pass`}</strong>{`. Pick `}<strong parentName="p">{`Light L`}</strong>{` + `}<strong parentName="p">{`Pouch`}</strong>{`, `}<strong parentName="p">{`Save & Reload`}</strong>{`, Tag `}<strong parentName="p">{`Everhold`}</strong>{` and exit.`}<br parentName="p"></br>{`
`}{`Run back to save, `}<strong parentName="p">{`Save & Reload`}</strong>{`. Pick `}<strong parentName="p">{`Pom M`}</strong>{`, go to `}<strong parentName="p">{`West Everhold Tunnels`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Pom L`}</strong>{`, reset steps. Pick `}<strong parentName="p">{`Knowledge Staff`}</strong>{`, `}<strong parentName="p">{`$35000`}</strong>{`.`}</p>
    <p>{`TP to `}<strong parentName="p">{`Sunshade`}</strong>{`, pick `}<strong parentName="p">{`Old Coin`}</strong>{`, head out to the right.`}</p>
    <p>{`Tag `}<strong parentName="p">{`Dancer Shrine`}</strong>{`, reload at south exit, tag `}<strong parentName="p">{`Wellspring`}</strong>{`. Get `}<strong parentName="p">{`Thunder L`}</strong>{` + `}<strong parentName="p">{`$20000`}</strong>{`, reset steps at `}<strong parentName="p">{`Marsalim Catacombs`}</strong>{`. Go to `}<strong parentName="p">{`Marsalim`}</strong>{`.`}</p>
    <p>{`Buy `}<strong parentName="p">{`Magic M`}</strong>{` from guy by entrance near shop. Go to palace, buy `}<strong parentName="p">{`Fire L, Wind L, Shadow L`}</strong>{` from right guard. Pick `}<strong parentName="p">{`Enchanted Circlet, $25,000, High House Armor`}</strong>{` in the three red chests in the room to the far right.`}</p>
    <p>{`TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}</p>
    <h3 {...{
      "id": "ophilia-ch1"
    }}>{`Ophilia Ch.1`}</h3>
    <Menu mdxType="Menu">
      <NoCait mdxType="NoCait">
        <h5 {...{
          "id": "jobs-1"
        }}>{`Jobs`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Scholar`}</strong>{`, Firestorm + Blizzard`}</li>
        </ul>
      </NoCait>
      <h5 {...{
        "id": "equipment"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Optimize, Elemental Augmentor, Elemental Robe`}</li>
        <li parentName="ul">{`Ophilia: Optimize, Empowering Bracelet, Unerring Bracelet`}</li>
      </ul>
      <NoCait mdxType="NoCait">
        <h5 {...{
          "id": "equip-skills-1"
        }}>{`Equip Skills`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Evasive Maneuvers`}</li>
        </ul>
      </NoCait>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "guardian"
      }}>{`Guardian`}</h4>
      <Cait mdxType="Cait">
        <blockquote>
          <p parentName="blockquote">{`Wind L + M Stone strat is only about 5s faster.`}</p>
        </blockquote>
        <h5 {...{
          "id": "turn-1-1"
        }}>{`Turn 1`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: `}{`[L]`}{` Staff`}</li>
          <li parentName="ul">{`Others: Defend`}</li>
        </ul>
        <h5 {...{
          "id": "turn-2-1"
        }}>{`Turn 2`}</h5>
        <ul>
          <li parentName="ul">{`Therion & Ophilia: Attack x3`}</li>
          <li parentName="ul">{`Tressa: Defend`}</li>
        </ul>
        <h5 {...{
          "id": "turn-3"
        }}>{`Turn 3`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Blizzard x4`}</li>
        </ul>
      </Cait>
      <NoCait mdxType="NoCait">
        <h5 {...{
          "id": "turn-1-2"
        }}>{`Turn 1`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Blizzard`}</li>
          <li parentName="ul">{`First other 2: Attack x2`}</li>
          <li parentName="ul">{`Last: Pom S Tressa`}</li>
        </ul>
        <h5 {...{
          "id": "turn-2-2"
        }}>{`Turn 2`}</h5>
        <ul>
          <li parentName="ul">{`Tressa: Blizzard x4`}</li>
          <li parentName="ul">{`Other: M Stone`}</li>
        </ul>
      </NoCait>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Sunshade`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch1"
    }}>{`Primrose Ch.1`}</h3>
    <NoCait mdxType="NoCait">
      <p>{`Replace Cyrus with Primrose`}</p>
    </NoCait>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "helgenish"
      }}>{`Helgenish`}</h4>
      <p>{`Blizzard x2, Ice M, Light M.`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-2"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Merchant`}</strong></li>
        <li parentName="ul">{`Therion: Armor Corrosive, `}<strong parentName="li">{`Warrior`}</strong></li>
        <li parentName="ul">{`Ophilia: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Scholar`}</strong>{`, Blizzard`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-1"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Unequip All`}</li>
        <li parentName="ul">{`Primrose: Optimize, Elemental Augmentor`}</li>
      </ul>
      <hr></hr>
      <h5 {...{
        "id": "formation"
      }}>{`Formation`}</h5>
      <Cait mdxType="Cait">
        <ul>
          <li parentName="ul">{`Tressa > Ophilia`}</li>
          <li parentName="ul">{`Ophilia > Primrose`}</li>
        </ul>
      </Cait>
      <NoCait mdxType="NoCait">
        <ul>
          <li parentName="ul">{`Tressa > Primrose`}</li>
          <li parentName="ul">{`Tressa > Therion`}</li>
        </ul>
      </NoCait>
      <h5 {...{
        "id": "items"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul"><em parentName="li">{`R1 1U 1L then Down for inputs`}</em></li>
        <li parentName="ul">{`Nourish S: Tressa`}</li>
        <li parentName="ul">{`All other Nuts on Primrose`}</li>
        <li parentName="ul">{`Heal Prim & Therion`}</li>
      </ul>
    </Menu>
    <h3 {...{
      "id": "ophilia-ch2"
    }}>{`Ophilia Ch.2`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Heavy Coin Pouch`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`2R to get cursor on Light L.`}</p>
    </blockquote>
    <p>{`Kill 1st screen battle with Blizzard x2. Kill 2nd screen battle with Shadow L.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "hrodvitnir"
      }}>{`Hrodvitnir`}</h4>
      <h5 {...{
        "id": "turn-1-3"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Blizzard`}</li>
        <li parentName="ul">{`Therion: Sword x2`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Ophilia: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-3"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Tressa: Attack`}</li>
        <li parentName="ul">{`Ophilia: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-1"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: HHV x4`}</li>
        <li parentName="ul">{`Primrose: Blizzard x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "ophilia-ch3"
    }}>{`Ophilia Ch.3`}</h3>
    <p>{`Buy `}<strong parentName="p">{`Empowering Bracelet & 2 Pom M`}</strong>{`. Pick `}<strong parentName="p">{`$4500`}</strong>{`. Before talking to the Bishop, buy `}<strong parentName="p">{`Empowering Ring & Pom M`}</strong>{`. TP `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-2"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ring`}</li>
        <li parentName="ul">{`Tressa: Optimize, Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "healing"
      }}>{`Healing`}</h5>
      <p>{`Heal to full.`}</p>
      <h5 {...{
        "id": "jobs-3"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lightning Blast`}</li>
        <li parentName="ul">{`Therion: 2 Warrior Skills, `}<strong parentName="li">{`Dancer`}</strong>{`, Peacock`}</li>
        <li parentName="ul">{`Tressa: Donate BP, `}<strong parentName="li">{`Warrior`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Hunter`}</strong>{`, Leghold + Arrowstorm`}</li>
        <li parentName="ul">{`Ophilia: Donate BP`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-2"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: EM`}</li>
        <li parentName="ul">{`Therion: Cover`}</li>
        <li parentName="ul">{`Tressa: EI + Cover + Heightened Senses`}</li>
        <li parentName="ul">{`Ophilia: EI`}</li>
      </ul>
    </Menu>
    <p>{`Go to `}<strong parentName="p">{`Northreach`}</strong>{`, kill Lizards on the way. Buy `}<strong parentName="p">{`Empowering Necklace`}</strong>{`, `}<strong parentName="p">{`Fool's Gold Ore & Curious Antique`}</strong>{`, `}<strong parentName="p">{`Magic L`}</strong>{`. Pick `}<strong parentName="p">{`Master's Longbow`}</strong>{`.`}</p>
    <p>{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`. `}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-3"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Therion: +Necklace`}</li>
      </ul>
      <h5 {...{
        "id": "items-1"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`2 Grapes Therion`}</li>
        <li parentName="ul">{`Magic L Primrose`}</li>
      </ul>
    </Menu>
    <p>{`Kill at least 1 battle in Ch.3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mystery-man--shady-figure"
      }}>{`Mystery Man & Shady Figure`}</h4>
      <h5 {...{
        "id": "turn-1-4"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Pom M Ophilia`}</li>
        <li parentName="ul">{`Therion: 2x Armor Corrosive MM`}</li>
        <li parentName="ul">{`Tressa: Attack MM`}</li>
        <li parentName="ul">{`Ophilia: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-4"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: `}{`[R]`}{` Spear x4`}</li>
        <li parentName="ul">{`Primrose: Pom M Alfyn`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive SF`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-2"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: HHMx4`}</li>
        <li parentName="ul">{`Ophilia: HHVx4`}</li>
        <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
      </ul>
    </Battle>
    <p>{`Finish chapter. TP `}<strong parentName="p">{`Noblecourt`}</strong>{`, run to `}<strong parentName="p">{`Wispermill`}</strong>{`. Can pick Light M on the way.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Cat's Eye`}</strong>{`. Kill Plains Drakes.`}</p>
    <h3 {...{
      "id": "ophilia-ch4"
    }}>{`Ophilia Ch.4`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Thunder M`}</strong>{` near the shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-1"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`[2U]`}{` Purifying Dust`}</li>
        <li parentName="ul">{`[R1]`}{` 2 Healing Grape M`}</li>
        <li parentName="ul">{`[1R1U]`}{` 11 Herbs of Clamor`}</li>
      </ul>
      <h5 {...{
        "id": "sell"
      }}>{`Sell`}</h5>
      <ul>
        <li parentName="ul">{`Master's Longbow, All Gold Items`}</li>
      </ul>
      <p>{`Take note of money. To have enough for Dreisang should have ~124300. Need to have at least 118200 here.`}</p>
    </Menu>
    <p>{`Pick `}<strong parentName="p">{`Giant's Club`}</strong>{`. Skip the hat and 30k. Can grab it if we don't skip battle.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "cultists"
      }}>{`Cultists`}</h4>
      <h5 {...{
        "id": "turn-1-5"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Pom S Self`}</li>
        <li parentName="ul">{`Therion: Peacock Primrose`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Ophilia: Holy Light`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-5"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: HHM x3`}</li>
        <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "mattias"
      }}>{`Mattias`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Can replace a Pom M with a Pom L, and skip Peacock`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-6"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Blizzard`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
        <li parentName="ul">{`Tressa: Pom M Ophilia`}</li>
        <li parentName="ul">{`Ophilia: Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Therion & Prim's actions depend on T3 turn order. Watch for who's last T3.`}</p>
        <ul parentName="blockquote">
          <li parentName="ul"><strong parentName="li">{`Primrose`}</strong>{`: 2 Pom M T2`}</li>
          <li parentName="ul"><strong parentName="li">{`Therion`}</strong>{`: 2 Pom M T2, M Stone`}</li>
          <li parentName="ul"><strong parentName="li">{`Merchant`}</strong>{`: Prim Pom M M1, Therion Peacock, Therion Pom M2 T3`}</li>
        </ul>
      </blockquote>
      <h5 {...{
        "id": "turn-2-6"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Ophilia: HHVx4`}</li>
        <li parentName="ul">{`Tressa: HHVx3`}</li>
        <li parentName="ul">{`Primrose: Pom M Tressa`}</li>
        <li parentName="ul">{`Therion: Peacock Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-3"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lighting Blast x4`}</li>
        <li parentName="ul">{`Tressa & Ophilia: HHVx3`}</li>
      </ul>
    </Battle>
    <p>{`Finish Ophi 4, TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Get `}<strong parentName="p">{`Badge of Friendship`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-4"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -Empowering Ring +Stimulating Bracelet`}</li>
        <li parentName="ul">{`Ophilia: Unequip All`}</li>
        <li parentName="ul">{`Tressa: +Badge of Friendship`}</li>
        <li parentName="ul">{`Therion: -Necklace +Bracelet +Ring`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Clearbrook`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch1"
    }}>{`Alfyn Ch.1`}</h3>
    <p>{`Get Alfyn, replace Ophi.`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "blotted-viper"
      }}>{`Blotted Viper`}</h4>
      <p>{`Blizzard x2 + Shadow L`}</p>
    </Battle>
    <p>{`Do this menu before resting at Alfyn's house.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-4"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`[3D]`}{` Merchant`}</strong>{`, Hired Help`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`[1U]`}{` Cleric`}</strong>{`, 4 Skills`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-5"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Optimize, +Necklace +Unerring Bracelet`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-3"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: -EM +Evil Ward`}</li>
      </ul>
    </Menu>
    <p>{`If you didn't get a drop, purchase `}<strong parentName="p">{`Essence of Pog`}</strong>{`. TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Need to kill at least 1 battle in this segment, preferably 2. Take note of how many you kill.`}</p>
    </blockquote>
    <p>{`Run to `}<strong parentName="p">{`Duskbarrow`}</strong>{`, kill the battle. For break better to use Alfyn + Prim, so Tressa can Donate BP. Optionally pick `}<strong parentName="p">{`Copper Pouch`}</strong>{`.`}</p>
    <p>{`Duskbarrow Battle Strats:`}</p>
    <ul>
      <li parentName="ul">{`Therion 1st: Fire M, LB x2, Ophi HHM x2, Tressa Defend. Donate BP x3 + LB x4`}</li>
      <li parentName="ul">{`Primrose 1st: LB, Peacock, HHB x2, Donate BP / Pom S. LB x4`}</li>
      <li parentName="ul">{`Merchant 1st: HHB x2, LB, Donate BP / Pom S, Peacock. LB x4`}</li>
    </ul>
    <p>{`In Duskbarrow buy `}<strong parentName="p">{`Curious Antique`}</strong>{`, pick `}<strong parentName="p">{`$30000 & Curious Antique`}</strong>{`. `}</p>
    <p>{`TP `}<strong parentName="p">{`Wispermill`}</strong>{`. Buy `}<strong parentName="p">{`Nourishing L`}</strong>{`, go to Shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "sell-1"
      }}>{`Sell`}</h5>
      <p>{`All Staffs.`}<br parentName="p"></br>{`
`}{`Gold Items.`}</p>
      <p>{`Need about $108000`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow / Duskbarrow`}</strong>{` and head to `}<strong parentName="p">{`Archmage Shrine`}</strong>{`.`}</p>
    <h4 {...{
      "id": "shrine-of-the-archmagus"
    }}>{`Shrine of the Archmagus`}</h4>
    <p>{`Pick `}<strong parentName="p">{`$20000, Wizard's Rod`}</strong>{` before Dreisang. You want to kill an encounter in here.`}<br parentName="p"></br>{`
`}{`After a battle do menu.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-2"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`Nourish L Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-5"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Donate BP, `}<strong parentName="li">{`Warrior`}</strong>{`, Spearhead + Thousand Spears`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`[2D]`}{` Dancer`}</strong>{`, Peacock + `}<strong parentName="li">{`Panther Dance`}</strong></li>
        <li parentName="ul">{`Therion: 1st 3 Thief Skills, `}<strong parentName="li">{`Merchant`}</strong>{`, Rest + Donate BP + Hired Help`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-4"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: EI + Cover`}</li>
        <li parentName="ul">{`Tressa: -Endless Items +The Show Goes On`}</li>
        <li parentName="ul">{`Therion: +Grow on Trees +Snatch `}<em parentName="li">{`Don't equip EI, for menuing optimization`}</em></li>
      </ul>
      <h5 {...{
        "id": "healing-1"
      }}>{`Healing`}</h5>
      <p>{`First Aid everyone to full. Always missing HP from Job change and Nourish L.`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dreisang-171469hp-44sp"
      }}>{`Dreisang 171469HP (44SP)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Fight requires 3 Pom L, 1 Pom M, 1/2 M Stone`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-7"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Pom L Therion`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive x2`}</li>
        <li parentName="ul">{`Tressa: Pom L Self`}</li>
        <li parentName="ul">{`Alfyn: Spearhead`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-7"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Thousand Spears`}</li>
        <li parentName="ul">{`Therion: HHV x4`}</li>
        <li parentName="ul">{`Tressa: HHV x4`}</li>
        <li parentName="ul">{`Primrose: Grape M`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Bonus here is Alfyn or Primrose before Therion, with standard saves a M Stone. Prim & Alfyn are interchangable.`}<br parentName="p"></br>{`
`}{`Damagewise, with current setup seem to kill by about 600 if Thunder M T4 and no M T5. Not sure if trustworthy, so opting for M Stone T6 if no bonus.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-4"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Pom L Therion`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive / Collect x4`}</li>
        <li parentName="ul">{`Tressa: HHV x3`}</li>
        <li parentName="ul">{`Alfyn: Pom M Tressa`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive / Collect x4`}</li>
        <li parentName="ul">{`Tressa: Thunder M`}</li>
        <li parentName="ul">{`Alfyn: `}{`[R]`}{` Sword x4`}</li>
      </ul>
      <h5 {...{
        "id": "turn-5"
      }}>{`Turn 5`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
        <li parentName="ul">{`Therion: HHV x3`}</li>
        <li parentName="ul">{`Tressa: HHV x4`}</li>
        <li parentName="ul">{`Alfyn: Purifying Dust + Essence of Pog`}</li>
      </ul>
      <h5 {...{
        "id": "turn-6"
      }}>{`Turn 6`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lightning Blast x4`}</li>
        <li parentName="ul">{`Therion: HHV xMAX`}</li>
        <li parentName="ul">{`Tressa: HHV x3`}</li>
        <li parentName="ul">{`Alfyn: M Stone if Therion HHV x3 T6`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-continued"
    }}>{`Therion Ch.2 Continued`}</h3>
    <p>{`Inquire `}<strong parentName="p">{`Better Thieving Tips & Tricks`}</strong>{`. Steal `}<strong parentName="p">{`Pom S, Invig M, Elemental Heavy Armor (80%)`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After stealing `}<strong parentName="p">{`Wyvern Scale`}</strong>{` TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2-start"
    }}>{`Alfyn Ch.2 Start`}</h3>
    <NoCait mdxType="NoCait">
      <p>{`Pick `}<strong parentName="p">{`Thunder L`}</strong></p>
    </NoCait>
    <p>{`Buy `}<strong parentName="p">{`Magic L`}</strong>{` `}<strong style={{
        color: 'red'
      }}>{` NOT Sharp M`}</strong>{` from Lysa.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-3"
      }}>{`Items`}</h5>
      <ul>
        <li parentName="ul">{`All nuts on Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "equipment-6"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Elemental Heavy Armor`}</li>
        <li parentName="ul">{`Tressa: Optimize (ERobe)`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-6"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Sorcerer`}</strong>{`, Lux + EBreak`}</li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Scholar`}</strong>{`, 4 Skills, `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-5"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Therion: +Precipence`}</li>
      </ul>
    </Menu>
    <p>{`Inquire guy in top part of town and TP `}<strong parentName="p">{`Quarrycrest`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch2-continued"
    }}>{`Tressa Ch.2 Continued`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "omar-72sp"
      }}>{`Omar (72SP)`}</h4>
      <h5 {...{
        "id": "turn-1-8"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Attack x2`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock Strut Primrose `}<strong parentName="li">{`(CHECK CURSOR)`}</strong></li>
        <li parentName="ul">{`Alfyn: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-8"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Donate BP x3`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`[L]`}{` Spear`}</strong>{` x3`}</li>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Tressa: Donate BP x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-5"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`Run to `}<strong parentName="p">{`Orewell`}</strong>{`. If only 1 battle in Dreisang section, kill the Orewell encounter.`}<br parentName="p"></br>{`
`}{`Ignis x2 + L + M or Ignis x4 + M + ~200 damage or Ignis x4 + Peacock. `}</p>
    <p>{`Tag `}<strong parentName="p">{`Orewell`}</strong>{`, tag `}<strong parentName="p">{`Riverford`}</strong>{`.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Goldshore`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch2-continued"
    }}>{`Alfyn Ch.2 Continued`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "vanessa"
      }}>{`Vanessa`}</h4>
      <h5 {...{
        "id": "turn-1-9"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock Strut Primrose`}</li>
        <li parentName="ul">{`Alfyn: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-9"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Donate BPx3`}</li>
        <li parentName="ul">{`Alfyn: Plum`}</li>
        <li parentName="ul">{`Primrose: Glacies x4`}</li>
        <li parentName="ul">{`Tressa: Donate BP x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-6"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`Finish chapter, TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-start"
    }}>{`Alfyn Ch.3 Start`}</h3>
    <p>{`Pick `}<strong parentName="p">{`Pom M`}</strong>{` if needed, Steal `}<strong parentName="p">{`Poms`}</strong>{`. Steal `}<strong parentName="p">{`Wind ML`}</strong>{`.`}<br parentName="p"></br>{`
`}{`After Tavern TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3-start"
    }}>{`Tressa Ch.3 Start`}</h3>
    <p>{`Steal `}<strong parentName="p">{`2 Shadow M`}</strong>{`. Save for Alaic (need 2)`}<br parentName="p"></br>{`
`}{`Buy `}<strong parentName="p">{`Edbart's Shield`}</strong>{` and `}<strong parentName="p">{`Plate Shield`}</strong>{` from story guy.`}<br parentName="p"></br>{`
`}{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-continued"
    }}>{`Alfyn Ch.3 Continued`}</h3>
    <p>{`After Inquire on 2nd screen TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "tressa-ch3-continued"
    }}>{`Tressa Ch.3 Continued`}</h3>
    <p>{`Pick `}<strong parentName="p">{`$15000`}</strong>{`.`}</p>
    <p>{`If Elementals use Ignis x2, If Serpent Ignis x4. Bats & Scorpions Glacies, Bones Lux`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "venomtooth-tiger-92sp"
      }}>{`Venomtooth Tiger (92SP)`}</h4>
      <h5 {...{
        "id": "turn-1-10"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock Strut`}</li>
        <li parentName="ul">{`Alfyn Defend`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`Watch turn order, if Therion after both Primrose & Tressa and Panther Dance would put him before 1 of them, Panther Dance Therion.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-2-10"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: `}{`[L]`}{` Spear x3`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Tressa: Panther Dance / Nothing`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`If Tressa Collect instead of Therion, pick `}<strong parentName="p">{`Silver Pouch`}</strong>{` & `}<strong parentName="p">{`Curious Antique`}</strong>{` in next 2 Chapters.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-7"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Collect x4`}</li>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Tressa: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`Finish chapter, TP `}<strong parentName="p">{`Stillsnow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch2-continued"
    }}>{`Primrose Ch.2 Continued`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "rufus-72sp"
      }}>{`Rufus (72SP)`}</h4>
      <h5 {...{
        "id": "turn-1-11"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend if first / `}{`[L]`}{` Staff`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock Strut Primrose (WATCH CURSOR)`}</li>
        <li parentName="ul">{`Alfyn: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-11"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}{`[L]`}{` Spear x3`}</li>
        <li parentName="ul">{`Alfyn: `}{`[L]`}{` Spear x3`}</li>
        <li parentName="ul">{`Primrose: Lux x4`}</li>
        <li parentName="ul">{`Tressa: Donate BP x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-8"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch2-continued-1"
    }}>{`Therion Ch.2 Continued`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "orlick-92sp"
      }}>{`Orlick (92SP)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Alternate Strat possible if Prim LVL28 and someone before her T1.`}<br parentName="p"></br>{`
`}{`Pom L Prim, Glacies x4 to kill adds. Get Peacock, E.Break T2 and break T2. Kill T3.`}<br parentName="p"></br>{`
`}{`Ideally skips 2 add turns and 1 Orlick turn. Everyone's default weapons hit shields.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-12"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
        <li parentName="ul">{`Therion/Alfyn: Pom M Primrose`}</li>
        <li parentName="ul">{`Therion/Alfyn: Plum M (has to be after Prim). If not just Defend, and Plum after the battle.`}</li>
        <li parentName="ul">{`Tressa: Peacock Strut Primrose`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-12"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Glacies x3`}</li>
        <li parentName="ul">{`Therion: Attack x3 / Defend`}</li>
        <li parentName="ul">{`Tressa: Donate BPx3`}</li>
        <li parentName="ul">{`Alfyn: Attack x3 / Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-9"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn/Therion: Attack x4`}</li>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Saintsbridge`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch3-continued-1"
    }}>{`Alfyn Ch.3 Continued`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "miguel-92sp"
      }}>{`Miguel (92SP)`}</h4>
      <h5 {...{
        "id": "turn-1-13"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lux x2`}</li>
        <li parentName="ul">{`Therion: Wind M / `}{`[R]`}{` Bow if Tressa before Primrose`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
        <li parentName="ul">{`Alfyn: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-13"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Sword x3`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: AC`}</li>
        <li parentName="ul">{`Tressa: Donate BP x2`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-10"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Therion: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`Before finishing chapter go to item shop.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "buy-2"
      }}>{`Buy`}</h5>
      <ul>
        <li parentName="ul">{`[L1 1D]`}{` 2 Injurious Dust`}</li>
        <li parentName="ul">{`[L1 1R]`}{` 2 of each Herb.`}</li>
      </ul>
      <h5 {...{
        "id": "sell-2"
      }}>{`Sell`}</h5>
      <p>{`All gold items, Wizard's Rod, Miguel's Spear, Omar's Axe`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Noblecourt`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch3"
    }}>{`Primrose Ch.3`}</h3>
    <p>{`Kill battle in Manse, always use Lux`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "albus-92sp"
      }}>{`Albus (92SP)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`There's a $12800 money swing here, depending on if Therion is before Tressa. Take note for later.`}<br parentName="p"></br>{`
`}{`If no good Tiger Collect, Therion can SP Thief to try to go for Panther Dance strat`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-14"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lux`}</li>
        <li parentName="ul">{`Therion: Attack`}</li>
        <li parentName="ul">{`Tressa: Dagger/Bow`}</li>
        <li parentName="ul">{`Alfyn Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-14"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Sword x3`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: AC`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-11"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Merchant 1: Collect x4`}</li>
        <li parentName="ul">{`Merchant 2: HHV x4`}</li>
      </ul>
    </Battle>
    <p>{`Watch Primrose JP, look for 4130.`}</p>
    <p>{`If < 2 Curious Blooms, Steal one from guy to the right.`}</p>
    <p>{`TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch3"
    }}>{`Therion Ch.3`}</h3>
    <p>{`If 4130JP on Primrose, can do this menu before adds fight and Night Ode them.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "learn-skills"
      }}>{`Learn Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<em parentName="li">{`IF 4130JP Peacock + Night Ode`}</em>{`, Tonitrus + Ventus`}</li>
        <li parentName="ul">{`Therion: Sidestep`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-6"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<em parentName="li">{`The Show Goes On`}</em>{` E.Aid + Stronger Strikes `}<em parentName="li">{`(Consider going 1 slot down if no Show)`}</em></li>
        <li parentName="ul">{`Therion: -Snatch +Hang Tough`}</li>
      </ul>
    </Menu>
    <p>{`Adds: Ignis x2 / Night Ode x2`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gareth-144sp"
      }}>{`Gareth (144SP)`}</h4>
      <h5 {...{
        "id": "turn-1-15"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Defend`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Alfyn: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-15"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Axe x2`}</li>
        <li parentName="ul">{`Primrose: Glacies x3`}</li>
        <li parentName="ul">{`Therion: Plum / Nothing`}</li>
        <li parentName="ul">{`Tressa: Donate BP x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-12"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`Tag `}<strong parentName="p">{`S'warkii`}</strong>{`. TP `}<strong parentName="p">{`Orewell`}</strong>{`.`}</p>
    <h3 {...{
      "id": "alfyn-ch4"
    }}>{`Alfyn Ch.4`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ogre-eagle-162sp"
      }}>{`Ogre Eagle (162SP)`}</h4>
      <h5 {...{
        "id": "turn-1-16"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Elemental Break x2`}</li>
        <li parentName="ul">{`Therion: Pom L Primrose`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
        <li parentName="ul">{`Alfyn: Injurious Dust + Curious Bloom`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-16"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Glacies x4`}</li>
        <li parentName="ul">{`Therion: Armor Corrosive`}</li>
        <li parentName="ul">{`Tressa: Donate BP`}</li>
        <li parentName="ul">{`Alfyn: Icicle / M Stone`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-13"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Merchants: HHV x4`}</li>
        <li parentName="ul">{`Alfyn: L Stone`}</li>
      </ul>
    </Battle>
    <p>{`If you don't have a Curious Bloom, Steal 1 from Meryl's Father.`}</p>
    <p>{`TP `}<strong parentName="p">{`Everhold`}</strong>{`.`}</p>
    <h3 {...{
      "id": "primrose-ch4"
    }}>{`Primrose Ch.4`}</h3>
    <p>{`Steal `}<strong parentName="p">{`2 Fire M, Fire L`}</strong>{`.`}<br parentName="p"></br>{`
`}{`Steal all L Stones & pick Light L. Can subtract one for each L Stone remaining from earlier count.`}<br parentName="p"></br>{`
`}{`Prioritize Wind L & Ice L, need for later.`}</p>
    <blockquote>
      <p parentName="blockquote">{`Keep track of extra Stones used. If extra L on Simeon or Ghisarma, Steal Fire L in Stonegard.`}<br parentName="p"></br>{`
`}{`If extra L Stone on both, use Ice L and pick up Ice L in Cyrus 4.`}</p>
    </blockquote>
    <Menu mdxType="Menu">
      <p>{`Heal if needed`}</p>
      <h5 {...{
        "id": "skills-3"
      }}>{`Skills`}</h5>
      <ul>
        <li parentName="ul">{`If Prim no Show Goes On, teach it.`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-7"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`Dancer`}</strong></li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`Cleric`}</strong>{`, Aelfrics`}</li>
        <li parentName="ul">{`Alfyn: `}<strong parentName="li">{`Merchant`}</strong></li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "simeon-1-164sp"
      }}>{`Simeon 1 (164SP)`}</h4>
      <h5 {...{
        "id": "turn-1-17"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock Self`}</li>
        <li parentName="ul">{`Therion: Pom M/L Tressa`}</li>
        <li parentName="ul">{`Tressa: Aelfrics / Defend`}</li>
        <li parentName="ul">{`Alfyn: Injurious Dust + Curious Bloom / Defend if Prim before puppets.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-17"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Ignis`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Alfyn: `}{`[L]`}{` Spear x3 Simeon`}</li>
        <li parentName="ul">{`Tressa: Aelfrics / Spear x3 Simeon / Light L / Nothing`}</li>
      </ul>
      <blockquote>
        <p parentName="blockquote">{`You need 2 L Stones if Ignis before breaking Simeon, 1 L Stone if after.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-3-14"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Steal x4 Female Puppet`}</li>
        <li parentName="ul">{`Primrose: Ignis x4`}</li>
        <li parentName="ul">{`Other: Light / Thunder L Stones as needed.`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "simeon-2"
      }}>{`Simeon 2`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Fight is flexible. With both buffs, need 2 Aelfric spells x3. With 1 buff, need 2 Aelfric spells x4 + a M Stone`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-18"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: E.Break x2`}</li>
        <li parentName="ul">{`Tressa: Clamor / HHM / Heal`}</li>
        <li parentName="ul">{`Therion: Steal SP`}</li>
        <li parentName="ul">{`H'aanit: Clamor / HHM / Heal`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-18"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`H'aanit: Donate BP x3`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-15"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Dagger x4`}</li>
        <li parentName="ul">{`Aelfics + Ignis x3/4`}</li>
        <li parentName="ul">{`Others get BP on Prim.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-4-1"
      }}>{`Turn 4`}</h5>
      <ul>
        <li parentName="ul">{`Sorc spell + M Stone if needed, etc.`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`S'warkii`}</strong>{`.`}</p>
    <h3 {...{
      "id": "haanit-ch1"
    }}>{`H'aanit Ch.1`}</h3>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-7"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Alfyn: Unequip All`}</li>
      </ul>
    </Menu>
    <p>{`Replace Alfyn`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-8"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: Optimize, +Necklace`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "ghisarma-72sp"
      }}>{`Ghisarma (72SP)`}</h4>
      <p>{`Glacies x3 / Ignis x4 / Glacies x2 + Peacock or 2M or L Stone`}</p>
    </Battle>
    <h3 {...{
      "id": "haanit-ch2"
    }}>{`H'aanit Ch.2`}</h3>
    <p>{`1st Provoke 2 Fire L + M`}</p>
    <p>{`Steal `}<strong parentName="p">{`Light L`}</strong>{` and `}<strong parentName="p">{`Shadow L`}</strong>{`.`}</p>
    <p>{`2nd Provoke Light L + L`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lord-of-the-forest"
      }}>{`Lord of the Forest`}</h4>
      <h5 {...{
        "id": "turn-1-19"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: Peacock`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`H'aanit: Pom S Tressa`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-19"
      }}>{`Turn 2`}</h5>
      <p>{`Aelfrics + Lux x3`}</p>
    </Battle>
    <h3 {...{
      "id": "haanit-ch3"
    }}>{`H'aanit Ch.3`}</h3>
    <p>{`Alaic: 2 Shadow M, Shadow L, L Stone`}</p>
    <Menu mdxType="Menu">
      <p>{`Heal Prim SP`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "dragon-164sp"
      }}>{`Dragon (164SP)`}</h4>
      <h5 {...{
        "id": "turn-1-20"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Lux`}</li>
        <li parentName="ul">{`Therion: Peacock x2`}</li>
        <li parentName="ul">{`Tressa: Defend / Tradewinds if Primrose before Therion to fill range.`}</li>
        <li parentName="ul">{`H'aanit: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-20"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: `}{`[L]`}{` Axe`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-16"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Aelfrics Primrose`}</li>
        <li parentName="ul">{`Prim: Ignis x4`}</li>
      </ul>
    </Battle>
    <h3 {...{
      "id": "haanit-ch4"
    }}>{`H'aanit Ch.4`}</h3>
    <p>{`Optionally Steal Pom Ls. Shouldn't be needed as long as you have a few Pom S.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "jobs-8"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`[3D]`}{` Warrior`}</strong>{`, 5 Skills, `}<strong parentName="li">{`[3U]`}{` Sorcerer`}</strong></li>
        <li parentName="ul">{`Therion: `}<strong parentName="li">{`[3D]`}{` Sholar`}</strong>{`, Alephans`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`[2U]`}{` Merchant`}</strong>{`, 2 Skills, `}<strong parentName="li">{`Cleric`}</strong></li>
        <li parentName="ul">{`Haanit: `}<strong parentName="li">{`[2D]`}{` Warrior`}</strong>{`, Thousand Spears`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-7"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -EM +Surpassing Power `}</li>
        <li parentName="ul">{`Tressa: -Heightened Sensed -The Show Goes On +EM +Hang Tough`}</li>
      </ul>
      <p>{`Re-open menu.`}</p>
      <h5 {...{
        "id": "items-4"
      }}>{`Items`}</h5>
      <p>{`Heal to full. Haanit missing HP from Job change is needed for Crit Rend safety.`}</p>
      <h5 {...{
        "id": "equipment-9"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Knowledge Staff`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "redeye-96sp"
      }}>{`Redeye (96SP)`}</h4>
      <h5 {...{
        "id": "turn-1-21"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock`}</li>
        <li parentName="ul">{`Therion: HP Thief / Fire Storm`}</li>
        <li parentName="ul">{`Tressa: Heal / Nothing`}</li>
        <li parentName="ul">{`H'aanit: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-21"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`H'aanit: Axe x3 / Thousand Spears`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion & Tressa: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-17"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Buffs + Ignis x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Flamesgrace`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-10"
      }}>{`Equipment`}</h5>
      <p>{`H'aanit: Unequip All`}</p>
    </Menu>
    <NoCait mdxType="NoCait">
      <p>{`Go to Tavern. Change party `}{`[1]`}{` Cyrus > H'aanit`}</p>
    </NoCait>
    <p>{`Buy `}<strong parentName="p">{`Bishop's Staff`}</strong>{`.`}</p>
    <Cait mdxType="Cait">
      <p>{`TP `}<strong parentName="p">{`Atlasdam`}</strong>{`.`}</p>
      <h3 {...{
        "id": "cyrus-ch1-1"
      }}>{`Cyrus Ch.1`}</h3>
    </Cait>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-11"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Bishop's Staff, Plate Shield (Optimize doesn't work)`}</li>
        <li parentName="ul">{`Cyrus: Optimize, Necklace`}</li>
      </ul>
    </Menu>
    <Cait mdxType="Cait">
      <Battle mdxType="Battle">
        <h5 {...{
          "id": "russell-1"
        }}>{`Russell`}</h5>
        <p>{`Glacies x2`}</p>
      </Battle>
    </Cait>
    <p>{`TP `}<strong parentName="p">{`Quarrycrest`}</strong></p>
    <h3 {...{
      "id": "cyrus-ch2"
    }}>{`Cyrus Ch.2`}</h3>
    <blockquote>
      <p parentName="blockquote">{`If Prim >= 2000JP, can do Job/Skill menu here instead of Yvon. You can then Pom S instead of Peacock, which means Prim can Defend.`}<br parentName="p"></br>{`
`}{`There's also a T1 break strat you can do with Mental Belt, Augmented & and a good turn order, but it only saves 5s or so and would require more Plums. You also lose 200EXP and 180JP from Skeletons not spawning.`}</p>
    </blockquote>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gideon-76sp"
      }}>{`Gideon (76SP)`}</h4>
      <h5 {...{
        "id": "turn-1-22"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock`}</li>
        <li parentName="ul">{`Therion: Defend / Alephans`}</li>
        <li parentName="ul">{`Tressa: Donate BP x2 Therion`}</li>
        <li parentName="ul">{`Cyrus: Plum M / Jam Prim if needed.`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-22"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Alephans`}</li>
        <li parentName="ul">{`Primrose: Lux x3 `}<strong parentName="li">{`Gideon`}</strong>{`.`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Stonegard`}</strong>{`.`}</p>
    <h3 {...{
      "id": "cyrus-ch3"
    }}>{`Cyrus Ch.3`}</h3>
    <p>{`Steal Stones if needed.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-12"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Gideon's Dagger, -Stimulating +Mental Belt`}</li>
      </ul>
      <h5 {...{
        "id": "jobs-9"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Tenebrae`}</li>
        <li parentName="ul">{`Cyrus: `}<strong parentName="li">{`[3D]`}{` Hunter`}</strong>{`, Leghold`}</li>
      </ul>
      <h5 {...{
        "id": "equip-skills-8"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -Stronger Strikes +Augmented Elements`}</li>
      </ul>
      <p>{`Heal if needed.`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "yvon-63522hp-92sp"
      }}>{`Yvon (63522HP, 92SP)`}</h4>
      <h5 {...{
        "id": "turn-1-23"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion/Cyrus: Attack x2 / Pom M Tressa`}</li>
        <li parentName="ul">{`Tressa: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-23"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Tressa: Aelfrics`}</li>
        <li parentName="ul">{`Primrose: Lux x4`}</li>
      </ul>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`Duskbarrow`}</strong>{`.`}</p>
    <p>{`Pick up HGB if only have 1, need 2.`}<br parentName="p"></br>{`
`}{`Pick `}<strong parentName="p">{`Knight Shield`}</strong>{`.`}</p>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items--healing"
      }}>{`Items / Healing`}</h5>
      <p>{`Heal everyone to full`}</p>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lucia-96sp"
      }}>{`Lucia (96SP)`}</h4>
      <blockquote>
        <p parentName="blockquote">{`Do 2 buffs if 1 before Lucia, if both after do 1 buff + 2 HGB. If free turn T2 can use other buff in that case.`}</p>
      </blockquote>
      <h5 {...{
        "id": "turn-1-24"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Peacock`}</li>
        <li parentName="ul">{`Therion/Tressa: +DEF / 1 HGB`}</li>
        <li parentName="ul">{`Cyrus: Leghold`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-24"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion & Tressa: Defend`}</li>
        <li parentName="ul">{`Cyrus: HGB`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-18"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Alephans + Aelfrics + Lux x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-13"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -Mental Belt +Stimulating Bracelet`}</li>
        <li parentName="ul">{`Cyrus: Unequip All`}</li>
        <li parentName="ul">{`Therion: Unequip All`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Cobbleston`}</strong>{`. `}</p>
    <h3 {...{
      "id": "olberic-ch1"
    }}>{`Olberic Ch.1`}</h3>
    <p>{`Replace Cyrus with Olberic`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "brigands"
      }}>{`Brigands`}</h4>
      <p>{`Night Ode / LB x2 / M Stone. `}<em parentName="p">{`Luminescence is a range`}</em></p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gaston"
      }}>{`Gaston`}</h4>
      <p>{`Ignis x2`}</p>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "equipment-14"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -Gideon's Dagger`}</li>
        <li parentName="ul">{`Olberic: Necklace + Ring, `}<strong parentName="li">{`DONT OPTIMIZE`}</strong></li>
      </ul>
      <h5 {...{
        "id": "jobs-10"
      }}>{`Jobs`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}<strong parentName="li">{`Merchant`}</strong>{`, Hired Help`}</li>
        <li parentName="ul">{`Tressa: `}<strong parentName="li">{`[3D]`}{` Dancer`}</strong></li>
      </ul>
      <h5 {...{
        "id": "equip-skills-9"
      }}>{`Equip Skills`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -The Show Goes On +Stronger Strikes`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Victor's Hollow`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch2"
    }}>{`Olberic Ch.2`}</h3>
    <p>{`Challenges HHV`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "victorino"
      }}>{`Victorino`}</h4>
      <p>{`Ventus x3 / Peacock + Ventus x2 / Ventus x2 + Wind/Shadow L`}</p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "joshua"
      }}>{`Joshua`}</h4>
      <p>{`Lux x4`}</p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "archibold"
      }}>{`Archibold`}</h4>
      <p>{`Tenebrae x4 + (Peacock OR ~2000 damage) / Tenebrae x3 + Peacock`}</p>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "gustav-39549hp"
      }}>{`Gustav (39549HP)`}</h4>
      <ul>
        <li parentName="ul">{`Prim 1st: Glacies x2, Therion Defend, Pom S Therion & Pom L Primrose. Then Alephans + Ignis x4`}</li>
        <li parentName="ul">{`Prim 2nd: Pom L, Lux x4, Peacock + Pom S Prim.`}</li>
        <li parentName="ul">{`Prim 3rd: Peacock, Pom L, Lux x3 + Ignis x4`}</li>
        <li parentName="ul">{`Dancer then Prim, Dancer after Prim T2: Do Alephans strat.`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <p>{`Heal Prim SP if under 72.`}</p>
      <h5 {...{
        "id": "equipment-15"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Gideon's Dagger`}</li>
      </ul>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch4-start"
    }}>{`Therion Ch.4 Start`}</h3>
    <p>{`Lux the fight. After Cathedral scene TP back to Victor's Hollow, finish Olberic Ch.2. TP `}<strong parentName="p">{`Wellspring`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch3"
    }}>{`Olberic Ch.3`}</h3>
    <p>{`If you have a Ice L, you can kill the first Lizards with Primrose Ice L thanks to Stronger Strikes!`}<br parentName="p"></br>{`
`}{`So only need 72.`}</p>
    <p>{`Lizards Ignis x2`}</p>
    <p>{`Heal SP if < 92`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "lizardmeme-king"
      }}>{`Lizardmeme King`}</h4>
      <h5 {...{
        "id": "turn-1-25"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: Peacock`}</li>
        <li parentName="ul">{`Tressa: Donate BP`}</li>
        <li parentName="ul">{`Olberic: Defend / Wind L`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-25"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Lux x4`}</li>
      </ul>
    </Battle>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "erhardt"
      }}>{`Erhardt`}</h4>
      <p>{`Shadow L, Defend, HHV x4`}</p>
    </Battle>
    <p>{`TP `}<strong parentName="p">{`RIVERFORD`}</strong></p>
    <h3 {...{
      "id": "olberic-ch4-start"
    }}>{`Olberic Ch.4 Start`}</h3>
    <p>{`Trigger cutscene on 2nd screen. TP `}<strong parentName="p">{`Northreach`}</strong>{`.`}</p>
    <h3 {...{
      "id": "therion-ch4-continued"
    }}>{`Therion Ch.4 Continued`}</h3>
    <p>{`8%. Go to Weapon Shop, sell Weapons. Can skip if you got good Albus Collect & Bishop Staff discount.`}<br parentName="p"></br>{`
`}{`Need `}<strong parentName="p">{`$39396`}</strong>{` before entering Lorn Cathedral.`}</p>
    <Menu mdxType="Menu">
      <blockquote>
        <p parentName="blockquote">{`Do NOT heal after this menu, you want the missing HP.`}</p>
      </blockquote>
      <h5 {...{
        "id": "formation-1"
      }}>{`Formation`}</h5>
      <p>{`Swap Tressa & Therion. This is for Cover mechanics.`}</p>
      <h5 {...{
        "id": "equipment-16"
      }}>{`Equipment`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: -Stimulating Bracelet +Empowering Bracelet +Vendetta Coat`}</li>
        <li parentName="ul">{`Olberic: Optimize`}</li>
      </ul>
    </Menu>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "darius-96sp"
      }}>{`Darius (96SP)`}</h4>
      <h5 {...{
        "id": "turn-1-26"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Attack`}</li>
        <li parentName="ul">{`Therion: Attack`}</li>
        <li parentName="ul">{`Tressa: Attack`}</li>
        <li parentName="ul">{`Olberic: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-26"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}{`[R]`}{` Spear`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-19"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Alephans`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux`}</strong>{` x4`}</li>
      </ul>
    </Battle>
    <Menu mdxType="Menu">
      <h5 {...{
        "id": "items-5"
      }}>{`Items`}</h5>
      <p>{`Only Olberic `}<Cait mdxType="Cait">{`and Tressa`}</Cait>{` should level here. Heal `}<strong parentName="p">{`ONLY`}</strong>{` SP on Primrose`}<NoCait mdxType="NoCait">{`, and HP on `}<strong parentName="p">{`ONLY`}</strong>{` Tressa`}</NoCait>{`.`}<br parentName="p"></br>{`
`}{`This sets up Tressa to Cover Primrose & Therion, which gets rid of Terror as an issue.`}</p>
    </Menu>
    <p>{`TP `}<strong parentName="p">{`Riverford`}</strong>{`.`}</p>
    <h3 {...{
      "id": "olberic-ch4-continued"
    }}>{`Olberic Ch.4 Continued`}</h3>
    <p>{`Red Hat: Red Apple, HHV x4, HHV x3`}</p>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "werner"
      }}>{`Werner`}</h4>
      <h5 {...{
        "id": "turn-1-27"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: Attack`}</li>
        <li parentName="ul">{`Therion: Attack`}</li>
        <li parentName="ul">{`Tressa: `}{`[R]`}{` Dagger x2`}</li>
        <li parentName="ul">{`Olberic: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-27"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: Tradewinds / HHB x2`}</li>
        <li parentName="ul">{`Primrose: EBreak`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-20"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Alephans`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux`}</strong>{` x4`}</li>
      </ul>
    </Battle>
    <blockquote>
      <p parentName="blockquote">{`Heal if needed. Tressa just needs to be above red HP. Prim needs SP and full HP.`}</p>
    </blockquote>
    <h3 {...{
      "id": "tressa-ch4"
    }}>{`Tressa Ch.4`}</h3>
    <Battle mdxType="Battle">
      <h4 {...{
        "id": "esmeralda"
      }}>{`Esmeralda`}</h4>
      <h5 {...{
        "id": "turn-1-28"
      }}>{`Turn 1`}</h5>
      <ul>
        <li parentName="ul">{`Primrose: `}{`[L]`}{` Staff`}</li>
        <li parentName="ul">{`Therion: `}{`[R]`}{` Staff`}</li>
        <li parentName="ul">{`Tressa: Attack`}</li>
        <li parentName="ul">{`Olberic: Defend`}</li>
      </ul>
      <h5 {...{
        "id": "turn-2-28"
      }}>{`Turn 2`}</h5>
      <ul>
        <li parentName="ul">{`Olberic: `}{`[R]`}{` Spear / HHB (x2)`}</li>
        <li parentName="ul">{`Primrose: E.Break`}</li>
        <li parentName="ul">{`Therion: Defend`}</li>
        <li parentName="ul">{`Tressa: Peacock`}</li>
      </ul>
      <h5 {...{
        "id": "turn-3-21"
      }}>{`Turn 3`}</h5>
      <ul>
        <li parentName="ul">{`Therion: Alephans`}</li>
        <li parentName="ul">{`Primrose: `}<strong parentName="li">{`Lux`}</strong>{` x4`}</li>
      </ul>
    </Battle>
    <p>{`GG!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      